import { render } from "./recommandSendItem.vue?vue&type=template&id=3163621d&scoped=true"
import script from "./recommandSendItem.vue?vue&type=script&lang=js"
export * from "./recommandSendItem.vue?vue&type=script&lang=js"

import "./recommandSendItem.vue?vue&type=style&index=0&id=3163621d&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3163621d"]])

export default __exports__